import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { MatchingSession } from '@data/session/session.model';
import { MatchingSessionOptions } from '@shared/menus/context-menu/context-menu-option/matching-session-options';
import { ContextMenuOption, ContextMenuTypes } from './context-menu-option/context-menu-option';
import { DialogService } from '@shared/components/dialog/dialog.service';
import { StopMenuOptions } from '@shared/menus/context-menu/context-menu-option/stop-menu-options';
import { NotificationService } from '@core/services/notification/notification.service';
import { IonosFacadeService } from '@core/services/upload/ionos-facade.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { StopService } from '@data/stop/stop.service';
import { StopDialogHandler } from '../../../lib/company-elements/services/stop-dialog-handler';
import { SessionQuery } from '@data/session/session.query';
import { SessionJobDatasetService } from '@data/session-job-dataset/session-job-dataset.service';
import getSessionMenuOptions = MatchingSessionOptions.getSessionMenuOptions;
import getStopMenuOptions = StopMenuOptions.getStopMenuOptions;

@Component({
  selector: 'recrewt-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
  standalone: false,
})
export class ContextMenuComponent<Target> implements OnInit {
  private dialog = inject<DialogService<any, string>>(DialogService);
  private notifier = inject(NotificationService);
  private stopService = inject(StopService);
  private stopDialogHandler = inject(StopDialogHandler);
  private sessionQuery = inject(SessionQuery);
  private sessionJobDataService = inject(SessionJobDatasetService);
  private upload = inject(IonosFacadeService);

  menuOptions: ContextMenuOption<any>[] | undefined;

  @Input() target: Target | undefined;

  @Input() menuType: ContextMenuTypes | undefined;

  @Input() isRightClick: boolean = false;

  @Input() afterClose?: () => void;

  @ViewChild(MatMenuTrigger, { static: false }) matMenuTrigger?: MatMenuTrigger;

  menuTopLeftPosition = { x: '0', y: '0' };

  ngOnInit(): void {
    if (this.target) {
      switch (this.menuType) {
        case ContextMenuTypes.MATCHING_SESSION: {
          this.menuOptions = getSessionMenuOptions(
            this.target as unknown as MatchingSession,
            this.dialog,
            this.notifier,
            this.upload,
            this.sessionJobDataService,
          );
          break;
        }
        case ContextMenuTypes.ATTENDANTS_CONTEXT:
        case ContextMenuTypes.ATTENDANTS_TABLE: {
          const session = this.sessionQuery.getActive();
          if (!session) return;
          this.menuOptions = getStopMenuOptions(
            this.target as any,
            session,
            this.dialog,
            this.notifier,
            this.stopService,
            this.stopDialogHandler,
            this.afterClose,
          );
          break;
        }

        default: {
          console.log('undefined context menu type');
          break;
        }
      }
    }
  }
}
